var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.as,{ref:"badge",tag:"component",class:[_vm.$style.text, _vm.cssClass],style:(_vm.cssStyles.badge)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }